// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y8au","colBig":"styles_colBig__3OcZB","colSmall":"styles_colSmall__25Wtp"};